import { SHELL_NAV_ITEMS, type ShellNavItem } from '../shell-nav.types';

export interface MenuLinkItem {
  readonly id: string;
  readonly labelKey: string;
  readonly url: string;
}

export type MenuNavItem = ShellNavItem;

export const MENU_NAV_ITEMS: readonly MenuNavItem[] = SHELL_NAV_ITEMS;

export const MENU_LOGO_FULL = 'assets/icon/medlink.svg';

export const MENU_LOGO_MARK = 'assets/icon/medlink-mark.svg';

export const MENU_CONTENT_WIDTH_CLASS = 'w-61';

export const MENU_ICON_TRACK_CLASS = 'menu-icon-track';

export const MENU_COLLAPSED_CONTROL_CLASS = 'flex size-10 shrink-0 items-center justify-center';

export const MENU_LOGO_MARK_CLASS = MENU_COLLAPSED_CONTROL_CLASS;
